import type { media as en } from "../en/media";
import type { Messages } from "../types";

export const media: Messages<typeof en> = {
  image: {
    unavailable: "الصورة غير متاحة",
    refreshing: "جارٍ تحديث الصورة…",
    copying: "جارٍ نسخ الوسائط…",
    copyingHint: "تحفظ منصة ملفك نسخة من وسائط هذا المنشور حتى لا تتعطل أبدًا.",
    video: "فيديو",
    notMirrored: "معروضة من إنستغرام (النسخ قيد الانتظار)",
  },
  reload: {
    action: "إعادة التحميل من إنستغرام",
    hint: "جلب النص والوسائط والأعداد والإحصاءات والتعليقات الجديدة من إنستغرام. تُحفظ التغييرات كإصدارات.",
    selected_zero: "إعادة تحميل المنشورات",
    selected_one: "إعادة تحميل منشور واحد",
    selected_two: "إعادة تحميل منشورين",
    selected_few: "إعادة تحميل {{count}} منشورات",
    selected_many: "إعادة تحميل {{count}} منشورًا",
    selected_other: "إعادة تحميل {{count}} منشور",
    account: "إعادة تحميل منشورات ‎@{{user}}",
    all: "إعادة تحميل كل المنشورات المستوردة",
    started: "بدأت إعادة التحميل",
    failed: "تعذّر بدء إعادة التحميل",
    select: "تحديد",
    selectAll: "تحديد كل المنشورات",
    selectPost: "تحديد المنشور",
    clear: "إلغاء التحديد",
  },
  refresh: {
    pictures: "إعادة تحميل الصور",
    picturesHint: "نسخ وسائط منشورات هذا الحساب وصور الملفات الشخصية إلى منصة ملفك من جديد.",
    started: "جارٍ تحديث الوسائط",
    failed: "تعذّر تحديث الوسائط",
  },
  edited: {
    badge: "عُدّل على إنستغرام",
    hint: "تغيّر المحتوى على إنستغرام {{when}}. الإصدارات السابقة محفوظة أدناه.",
  },
  versions: {
    title: "الإصدارات",
    hint: "كل تغيير على النص أو الوسائط، من إنستغرام أو من منصة ملفك.",
    empty: "لا توجد إصدارات بعد. إعادة التحميل من إنستغرام تسجّل إصدارًا عند وجود تغيير.",
    current: "الحالي",
    version: "الإصدار {{n}}",
    source: {
      import: "مستورد",
      instagram_edit: "عُدّل على إنستغرام",
      malfak_edit: "عُدّل في منصة ملفك",
    },
    compareWith: "التغييرات عن الإصدار {{n}}",
    firstVersion: "الإصدار الأول: لا يوجد ما يُقارن به.",
    noChanges: "النص مطابق للإصدار السابق.",
    added: "مُضاف",
    removed: "محذوف",
    before: "قبل",
    after: "بعد",
    media: "الوسائط",
    noMedia: "بلا وسائط",
    mediaCount_zero: "لا عناصر",
    mediaCount_one: "عنصر واحد",
    mediaCount_two: "عنصران",
    mediaCount_few: "{{count}} عناصر",
    mediaCount_many: "{{count}} عنصرًا",
    mediaCount_other: "{{count}} عنصر",
    restore: "استعادة",
    restoreTitle: "استعادة الإصدار {{n}}؟",
    restoreBody: "سيعرض ملفك نص هذا الإصدار ووسائطه. لن يتغيّر شيء على إنستغرام: واجهته البرمجية لا تسمح بتعديل نص منشور منشور.",
    restored: "تمت استعادة الإصدار {{n}} في منصة ملفك",
    restoreFailed: "تعذّرت استعادة هذا الإصدار",
    localOnly: "محلي فقط",
  },
  repair: {
    title: "إصلاح الوسائط",
    hint: "ينسخ كل صورة من إنستغرام ما زال ملفك يشير إليها (المنشورات، صور الملفات الشخصية، مرفقات الرسائل) إلى التخزين. يمكن تشغيله مرة أخرى بأمان.",
    org: "إعادة تحميل كل الصور",
    orgHint: "نسخ أي صورة لم تُحفظ في منصة ملفك بعد.",
    started: "بدأ إصلاح الوسائط",
    failed: "تعذّر بدء إصلاح الوسائط",
    runAll: "إصلاح كل المؤسسات",
    run: "إصلاح",
    posts: "المنشورات",
    avatars: "الصور الشخصية",
    attachments: "المرفقات",
    failedItems: "فشل",
    lastRun: "آخر تشغيل {{when}}",
    never: "لم يُشغَّل بعد",
    allClear: "كل الصور محفوظة في التخزين.",
    config: "نسخ الفيديو: {{videos}} · حد الصورة {{image}} م.ب · حد الفيديو {{video}} م.ب",
    yes: "نعم",
    no: "لا",
    lastJob: "آخر مهمة",
  },
};
